import type { SectionProps } from '@/types';

export function QrSection({ business, config }: SectionProps) {
  const title = (config.title as string) || 'Scan our QR code';
  const subtitle =
    (config.subtitle as string) ||
    'Save this business to your phone or share with friends';

  const qrUrl = business.qr_code_url;
  const pageUrl = typeof window !== 'undefined' ? window.location.href : '';

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: business.name,
          text: business.tagline ?? `Check out ${business.name} on QRBusiness India`,
          url: pageUrl,
        });
      } catch {
        /* user cancelled */
      }
    } else if (navigator.clipboard) {
      await navigator.clipboard.writeText(pageUrl);
    }
  };

  return (
    <section className="section-card">
      <div className="flex flex-col items-center gap-6 sm:flex-row sm:items-start">
        <div className="flex shrink-0 flex-col items-center">
          {qrUrl ? (
            <img
              src={qrUrl}
              alt={`QR code for ${business.name}`}
              className="h-40 w-40 rounded-brand border border-slate-200 bg-white p-2 shadow-sm"
            />
          ) : (
            <div className="flex h-40 w-40 items-center justify-center rounded-brand border-2 border-dashed border-slate-300 bg-slate-50">
              <svg className="h-16 w-16 text-slate-300" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm13-2h3v2h-3v-2zM14 13h2v2h-2v-2zm2 2h2v2h-2v-2zm-2 2h2v2h-2v-2zm2 2h2v2h-2v-2zm2-2h2v2h-2v-2zm0-4h2v2h-2v-2zm2 2h3v2h-3v-2z" />
              </svg>
            </div>
          )}
          <p className="mt-2 text-xs text-slate-500">Scan to visit</p>
        </div>

        <div className="flex-1 text-center sm:text-left">
          <h2 className="text-xl font-semibold text-slate-900">{title}</h2>
          <p className="mt-2 text-sm text-slate-600">{subtitle}</p>

          <div className="mt-4 flex flex-wrap justify-center gap-2 sm:justify-start">
            <button
              type="button"
              onClick={handleShare}
              className="inline-flex items-center gap-2 rounded-brand border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
            >
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
              </svg>
              Share
            </button>
            {pageUrl && (
              <button
                type="button"
                onClick={() => navigator.clipboard?.writeText(pageUrl)}
                className="inline-flex items-center gap-2 rounded-brand bg-slate-100 px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-200"
              >
                Copy link
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
